<div *ngIf="isLoaded">
    <div class="row">
        <div class="col-md-6 col-6 mb-4">
            <a routerLink="../../../oferte/editare-oferta/{{offerData.id}}" class="btn text-white green-bg">Editeaza
                Oferta</a>
        </div>
        <div class="col-md-6 col-6 text-right mb-4">
            <a routerLink="../../../oferte/lista-oferte" class="btn text-white blue-bg">Toate Ofertele</a>
        </div>
    </div>

    <div class="card card-custom gutter-b">
        <div class="card-header">
            <div class="card-title">
                <h3 class="card-label">Nume Oferta: {{offerData.name}}</h3>
            </div>
            <div class="card-title">
                <h3 class="card-label">Nr: {{offerData.docNumber}}</h3>
            </div>
        </div>
        <div class="card-body">
            <div class="row mb-10">
                <div class="col-12 mb-2">
                    <span class="font-weight-bold">Nume Client:</span> {{offerData.clientName}}
                </div>
                <div class="col-6">
                    <span class="font-weight-bold">Data Postare:</span> {{offerData.offerDate}}
                </div>
                <div class="col-6">
                    <span class="font-weight-bold">Data Expirare:</span> {{offerData.deadline}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-12">
                    <ul class="list-unstyled" *ngFor="let product of offerData.productList">
                        <li><span class="font-weight-bold mr-2">Nume Produs:</span>{{product.name}}</li>
                        <li><span class="font-weight-bold mr-2">Pret:</span>{{product.price}} Euro</li>
                        <hr>
                    </ul>
                </div>
                <div class="col-md-6 col-12">
                    <ul class="list-unstyled" *ngFor="let note of offerData.personalNotes">
                        <li><span class="font-weight-bold mr-2">Autor:</span>{{note.authorName}}</li>
                        <li><span class="font-weight-bold mr-2">Nota:</span>{{note.note}}</li>
                        <li><span class="font-weight-bold mr-2">Data Postare Notita:</span>{{note.date}}</li>
                        <hr>
                    </ul>
                </div>
            </div>

            <div class="row mt-20" *ngIf="offerData.observation != ''">
                <div class="col-12">
                    <div class="alert observation-alert" role="alert">
                        <span class="font-weight-bold mr-2">Observatie:</span>{{offerData.observation}}
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer bg-transparent row align-items-center">
            <div class="col-md-6">
                <h4>Pret: {{offerData.totalPrice}} Euro</h4>
            </div>
            <div class="col-md-6 d-flex justify-content-end">
                <a (click)="generatePdf()" class="btn btn-primary font-weight-bold text-uppercase px-9 py-4">Exporta in PDF <i class="icofont-file-pdf"></i></a>
            </div>
        </div>
    </div>
</div>
